import { Button } from "@gigpro/ui/Button";
import { ChevronDown, Location } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";
import { useContextLocations } from "api/queries/locations";
import { OrganizationSwitcher } from "domains/orgs/containers/OrganizationSwitcher";
import { Navigation } from "lucide-react";
import type React from "react";
import { useActiveLocation, useStoredLocationId } from "services/locationOrgContext";

type LocationBarProps = {
  ref?: React.Ref<HTMLDivElement>;
  disabled?: boolean;
  className?: string;
};

export const LocationBar = ({ ref, disabled, className }: LocationBarProps) => {
  const [activeLocation] = useActiveLocation();
  const storedLocationId = useStoredLocationId();
  const { data: locations, isLoading } = useContextLocations();
  const isDeepLink = storedLocationId !== undefined && !!activeLocation && storedLocationId !== activeLocation.id;
  const PrefixIcon = isDeepLink ? Navigation : Location;

  if (!(isLoading || (locations?.length ?? 0) > 0)) return null;

  const trigger = (
    <Button
      variant="raised"
      data-testid="dropdown_locationselection"
      className="group w-full text-large"
      disabled={disabled}
    >
      <PrefixIcon
        className="mr-auto size-4"
        aria-label={isDeepLink ? "Viewing a different location than your saved one" : undefined}
      />
      {activeLocation?.name}
      <ChevronDown
        className={cn(
          "ml-auto size-4 transition-all group-data-[state=open]:rotate-180",
          disabled && "text-transparent",
        )}
      />
    </Button>
  );

  const wrapperClassName = cn("min-w-60 justify-start bg-black p-2 md:bg-transparent md:p-0", className);

  return (
    <div ref={ref} className={wrapperClassName}>
      <OrganizationSwitcher className="w-full" asChild>
        {trigger}
      </OrganizationSwitcher>
    </div>
  );
};
